import { CHAT_NATURAL_TONE_EXPERIMENT_QUERY_PARAM } from "~shared/chatPersonalization";

function isTruthyQueryFlag(raw: string | null | undefined): boolean {
  if (!raw) return false;
  const normalized = raw.trim().toLowerCase();
  return (
    normalized === "1" ||
    normalized === "true" ||
    normalized === "yes" ||
    normalized === "on" ||
    normalized === "enabled"
  );
}

/**
 * Reads the experiment flag from the URL. Checks both the real query string (`location.search`)
 * and, if missing, any query substring inside the hash (e.g. `#doc=id?chat_natural_tone_exp=1`),
 * since the app keeps routing state in the fragment and users often append params there.
 */
export function isChatNaturalToneExperimentEnabledFromLocationParts(search: string, hash: string): boolean {
  const fromSearch = new URLSearchParams(search || "").get(CHAT_NATURAL_TONE_EXPERIMENT_QUERY_PARAM);
  if (isTruthyQueryFlag(fromSearch)) return true;

  const qInHash = (hash || "").indexOf("?");
  if (qInHash === -1) return false;
  const fromHash = new URLSearchParams(hash.slice(qInHash + 1)).get(CHAT_NATURAL_TONE_EXPERIMENT_QUERY_PARAM);
  return isTruthyQueryFlag(fromHash);
}
